// extracted by mini-css-extract-plugin
export default {"wrapper":"status_wrapper__9gjpg","status":"status_status__NW95e"};